import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
Vue.use(Router)
import router from './routers.js'
import '@/assets/index-BEc8vQlo.css'
import '@/assets/global.less' /*引入公共样式*/

import 'vant/lib/index.css'


// 基础组件的自动化全局注册。全局注册的行为必须在根 Vue 实例 (通过 new Vue) 创建之前发生
import './components/index'

import VueKonva from 'vue-konva';

Vue.use(VueKonva);

// 判断是否为移动设备的工具函数
Vue.prototype.isMobileDevice = function() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(userAgent);
}

// 全局变量，用于判断是否为移动设备
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
  navigator.userAgent.toLowerCase()
);

// 将是否为移动设备状态添加到Vue原型上，方便在所有组件中使用
Vue.prototype.$isMobile = isMobile;


Vue.prototype.back=function () {
	if (window.history.length <= 1) {
	    this.$router.push({path:'/'})
	    return false
	} else {
	    this.$router.go(-1)
	}
}

Vue.prototype.openUrl=function (url) {
	this.$router.push({path:url})
	
}

// 添加用于模拟登录和退出的方法
Vue.prototype.login = function(token, expiresIn = 7200) { // 默认2小时过期
  const now = new Date().getTime();
  const expiresAt = now + expiresIn * 1000; // 转换为毫秒
  
  // 存储token和过期时间
  localStorage.setItem('virbac-token', token);
  localStorage.setItem('virbac-token-expires', expiresAt);
}

Vue.prototype.logout = function() {
  localStorage.removeItem('virbac-token');
  localStorage.removeItem('virbac-token-expires');
  this.$router.push('/login');
}

// 检查是否已登录，未登录则重定向到登录页
// 在手机端跳过登录检查
if (!isMobile) {
  const token = localStorage.getItem('virbac-token');
  if (!token && window.location.pathname !== '/login') {
    router.push('/login');
  }
}

// 检查令牌是否过期
function isTokenExpired() {
  const expireTime = localStorage.getItem('virbac-token-expires');
  if (!expireTime) return true;
  
  const now = new Date().getTime();
  return now >= parseInt(expireTime);
}

// 检查登录令牌是否有效
Vue.prototype.checkToken = function() {
  // 如果是移动设备，跳过token检查
  if (isMobile) {
    return true;
  }
  
  const token = localStorage.getItem('virbac-token');
  
  // 如果没有令牌或令牌已过期，则登出
  if (!token || isTokenExpired()) {
    console.log('Token expired or not found, logging out');
    this.logout();
    return false;
  }
  
  return true;
}

// 设置定期检查登录状态
const checkTokenInterval = 60000; // 每分钟检查一次

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

const app = new Vue({
  render: h => h(App),
  router,
  mounted() {
    // 只在非移动设备上启动自动检查登录状态的定时器
    if (!isMobile) {
      this.tokenCheckTimer = setInterval(() => {
        if (this.checkToken && !this.checkToken()) {
          clearInterval(this.tokenCheckTimer);
        }
      }, checkTokenInterval);
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.tokenCheckTimer) {
      clearInterval(this.tokenCheckTimer);
    }
  }
}).$mount('#root')
